(function() {
    'use strict';
    angular.module('GorillaBoy.services')
    .factory('TokenService', [
        '$q',
        'MetricEvents',
        'AppConstants',
        'localStorageService',
        '$routeParams',
        'EndpointService',
        '$http',
        'ClientMetricsService',
        TokenService
    ]);

    function TokenService($q, MetricEvents, AppConstants, localStorageService, $routeParams, EndpointService, $http, ClientMetricsService) {
        var service = {},
            httpMethods = AppConstants.HttpMethods;

        service.tokenizeRequest = function(request) {
            return angular.extend({}, request, {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                    //The web client should add "Bearer " prefix to the HTTP calls
                    'Authentication' : localStorageService.get("gb_access_token")
                }
            });
        };

        service.getClientPath = function() {
            var pathname = window.location.pathname;
            var appNameRegExp = /^\/(workdocs[^\/]*)\//;
            if (appNameRegExp.test(pathname)) {
                return (pathname.match(appNameRegExp)[1]);
            }
        };

        service.propagateAccessTokenToTokenService = function() {
            return $routeParams.officeEditor ? service.propagateAccessTokenToTokenServiceTemplate(EndpointService.wopiEndpoint()) : "";
        };

        service.createSecureToken = function(docId, versionId, siteReturnPath) {
            return service.createSecureTokenTemplate(docId, versionId, siteReturnPath, EndpointService.wopiEndpoint());
        };

        service.propagateAccessTokenToTokenServiceHancom = function() {
            return $routeParams.editOnline ? service.propagateAccessTokenToTokenServiceTemplate(EndpointService.wdCollabServiceEndpoint()) : "";
        };

        service.createSecureTokenHancom = function(docId, versionId, siteReturnPath) {
            return service.createSecureTokenTemplate(docId, versionId, siteReturnPath, EndpointService.wdCollabServiceEndpoint());
        };

        service.propagateAccessTokenToTokenServiceTemplate = function(endPoint) {
            if (!($routeParams.documentId && ($routeParams.officeEditor || $routeParams.editOnline))) {
                // do not propagate when not in editing session (i.e., Office 365 editing session or Hancom session)
                return;
            }
            var expirationTimeStamp = localStorageService.get('gb_access_token_exp');

            var req = {
                method: httpMethods.PATCH,
                url: endPoint + '/api/v1/token',
                data: {
                    ExpirationTimeStamp : expirationTimeStamp
                }
            };
            ClientMetricsService.addEventObjectToSession({
                name : MetricEvents.TOKEN_SERVICE.TOKEN_REFRESH_PROPAGATION,
                documentId : $routeParams.documentId
            });
            return $http(service.tokenizeRequest(req));
        };

        service.createSecureTokenTemplate = function(docId, versionId, siteReturnPath, endPoint) {

            var clientAppName = service.getClientPath();
            var req = {
                method: httpMethods.POST,
                url: endPoint + '/api/v1/token',
                data: {
                    ResourceId : docId,
                    VersionId : versionId,
                    ClientAppName : clientAppName ? clientAppName : "workdocs",
                    ClientReturnPath : siteReturnPath ? siteReturnPath : "UNUSED"
                }
            };
            return $q(function(resolve, reject) {
                $http(service.tokenizeRequest(req)).then(function(response) {
                    var data = response.data;
                    if (!data || !data.SecureToken) {
                        reject(response);
                    }
                    resolve(data.SecureToken);
                }, reject);
            });
        };
        return service;
    }

}());